import QueueLoadMonitoring from "../Components/QueueLoadMonitoring/QueueLoadMonitoring";

const QueueLoadMonitoringPage = () => {
  return <QueueLoadMonitoring />;
};

export default QueueLoadMonitoringPage;
